// extracted by mini-css-extract-plugin
export default {"pdf_container":"certificatelist_pdf_container__9NKMt"};